<template>
  <div>
    <b-modal
      id="selectClientModal"
      ref="selectClientModal"
      centered
      :no-close-on-backdrop="true"
      title="Select Client"
      size="xl"
      hide-footer
      @hidden="resetSeachClientData"
    >
      <b-overlay
        id="overlay-background"
        :show="loader === true"
        variant="dark"
        opacity="0.85"
        blur="2px"
        rounded="sm"
        spinner-variant="primary"
        spinner-medium
      >
        <b-row class="m-2">
          <b-col>
            <b-form-input
              v-model="search"
              class="d-inline-block mr-1"
              placeholder="Search..."
              @change="searchClient($event)"
            />
          </b-col>
        </b-row>
        <b-row class="m-2">
          <b-col>
            <template v-if="items.length === 0">
              <div>
                <b-alert
                  variant="warning"
                  show
                  class="p-1"
                >
                  {{ $t('NO_CLIENT_FOUND') }}
                </b-alert>
              </div>
            </template>
            <template v-else>
              <b-table
                ref="clients"
                class="position-relative"
                :fields="fields"
                :items="items"
              >
                <template
                  #cell(select)="data"
                >
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    v-b-modal.clientInfoModal
                    size="sm"
                    variant="primary"
                    class="m-1"
                    :disabled="data.item.bc_customer_id ? false : true"
                    @click="selectClient(data.item.id)"
                  >
                    {{ $t('DEBTIA_SELECT') }}
                  </b-button>
                </template>
              </b-table>
            </template>
          </b-col>
        </b-row>
      </b-overlay>
    </b-modal>
  </div>
</template>

<script>
import {
  BModal, BOverlay, BTable, BRow, BCol, BButton,
  BFormInput, BAlert,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BModal,
    BOverlay,
    BTable,
    BRow,
    BCol,
    BButton,
    BFormInput,
    BAlert,
  },
  directives: {
    Ripple,
  },
  props: {
    clientsData: {
      type: Array,
      required: true,
    },
    loader: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      // loader: false,
      fields: [
        { key: 'name', label: 'Name' },
        { key: 'cvrcpr', label: 'CVR' },
        { key: 'phone', label: 'Phone' },
        { key: 'email', label: 'Email' },
        { key: 'select', label: 'Option' },
      ],
      items: [...this.clientsData],
      search: '',
    }
  },
  watch: {
    clientsData: {
      immediate: true, // Trigger on initial load
      handler(newClients) {
        this.items = [...newClients] // Update items when clientsData changes
      },
    },
  },
  methods: {
    selectClient(id) {
      this.loader = true
      this.$emit('selected-client', { id })
      this.$refs.selectClientModal.hide()
      this.loader = false
    },
    searchClient(event) {
      // if (event === '' || event === null) {
      //   this.items = [...this.clientsData]
      // } else {
      //   this.items = this.clientsData.filter(e => e.name.toLowerCase().includes(event.toLowerCase())
      //     || e.email.toLowerCase().includes(event.toLowerCase())
      //     || (e.cvrcpr && e.cvrcpr.toLowerCase().includes(event.toLowerCase()))
      //     || e.phone.toLowerCase().includes(event.toLowerCase()))
      // }
      this.$emit('search-clients', event)
    },
    resetSeachClientData() {
      // Reset the search input and items list
      this.search = ''
      // this.items = [...this.clientsData]
      this.$emit('search-clients', '')
    },
  },
}
</script>
